export const getMessages = state => state.getIn(['messages', 'splashMessages']);
